import React, { useContext, useState, useEffect } from "react";
// import ProfileCard from "./components/profileCard";
import Layout from "./components/Layout";
import Profile from "./components/Profile";
// import BankAccount from "./components/BankAccount";
// import Language from "./components/Language";
import AuthContext from "../../context/AuthContext";
import Loader from "../../components/Loader";


export default function Settings() {
  const { getUserInfo, userInfo } = useContext(AuthContext);
 
  useEffect(() => {
    (async()=>{
      await getUserInfo();
    })();
  }, [])
  return (
    <div className="flex w-full flex-col gap-5">
      <div className="mt-5">
        <Layout>
        {!userInfo.email && <Loader/> }
        {userInfo.email && <Profile userInfo={userInfo} />}
          {/* <BankAccount/>
          <Language/> */}
        </Layout>
      </div>
    </div>
  );
}
